import { AxiosResponse } from 'axios';

import { phpApi } from '../../../api';
import { EventDetails, TrainerMetric } from '../trainingV2.types';

export const getEventDetails: (id: number) => Promise<EventDetails>
  = async (id: number): Promise<EventDetails> => {
    const { data }: AxiosResponse<EventDetails> = await phpApi.get(`/api/events/${id}`);

    return data;
  };

export const getTrainerMetric: (id: number) => Promise<TrainerMetric>
  = async (id: number): Promise<TrainerMetric> => {
    const { data }: AxiosResponse<TrainerMetric> = await phpApi.get(`/api/user/${id}/metrics`);

    return data;
  };
